import axios from 'axios'
import * as Sentry from '@sentry/react'
import i18n from 'i18next'

export const apiClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL!}`,
  withCredentials: true,
  timeout: 7500
})

// Add request interceptor to set accept-language header based on current i18n language
apiClient.interceptors.request.use(
  config => {
    const currentLanguage = i18n.language
    if (currentLanguage) {
      config.headers['accept-language'] = currentLanguage
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  response => response,
  error => {
    console.log('[API Client] Error:', error.response?.data)

    try {
      if (error.response?.status >= 500) {
        Sentry.captureException(error)
      }
    } catch {
      // do nothing
    }

    throw error
  }
)
